import ReactSelect, {
  Props,
  components,
  ClearIndicatorProps,
} from 'react-select'
import { cn } from '../UI/cn'
import React, { forwardRef } from 'react'
import { useModalDepth } from '../UI/Modal/ModalPrimitive'
import { getDropdownZIndex } from '../../styles/z-index'
import { BsXCircleFill } from 'react-icons/bs'

// Custom clear indicator to match FilterCloseButton styling
const CustomClearIndicator = (
  props: ClearIndicatorProps<any, boolean, any>
) => {
  return (
    <components.ClearIndicator {...props}>
      <BsXCircleFill className="w-[13px] h-[13px] text-new-company-gray-inactive cursor-pointer" />
    </components.ClearIndicator>
  )
}

const ReactSelectWrapper = forwardRef<any, Props>((props, ref) => {
  const modalDepth = useModalDepth()
  const zIndex = React.useMemo(
    () => getDropdownZIndex(modalDepth),
    [modalDepth]
  )

  return (
    <ReactSelect
      menuPortalTarget={document.body}
      closeMenuOnScroll={false}
      blurInputOnSelect={false}
      captureMenuScroll={false}
      menuShouldBlockScroll={false}
      isOptionDisabled={(option: any) => option.disabled}
      components={{
        ClearIndicator: CustomClearIndicator,
        ...props.components,
      }}
      {...props}
      styles={{
        ...props.styles,
        menuPortal: (provided) => ({
          ...provided,
          zIndex,
          pointerEvents: 'all',
        }),
        control: (provided, state) => ({
          // ...provided,
          ...props.styles?.control?.(provided, state),
          display: 'flex',
          minHeight: '33.5px',
        }),
        placeholder: (provided, state) => ({
          ...provided,
          ...props.styles?.placeholder?.(provided, state),
          color: undefined,
        }),
      }}
      classNames={{
        ...props.classNames,
        control: (provided) => {
          return cn(
            'form-control-select',
            {
              'form-control-select-focus': provided.isFocused,
              'opacity-50': props.isDisabled,
            },
            props.classNames?.control?.(provided) ?? ''
          )
        },
        placeholder: (provided) =>
          'form-control-select-placeholder' +
          (props.classNames?.placeholder?.(provided) ?? ''),
        option: (provided) =>
          `${provided.isFocused ? 'hover-menu-item' : ''} ${
            provided.isSelected ? 'selected-menu-item' : ''
          }` + (props.classNames?.option?.(provided) ?? ''),
      }}
      ref={ref}
    />
  )
})

ReactSelectWrapper.displayName = 'ReactSelectWrapper'

export default ReactSelectWrapper
